<template>
  <FlexRow :space="0" align="end">
    <Label :text="loggedInAt" />
    <HotIcon v-show="toDaysAfter(lastLoggedInAt) > -14" class="caution--text" />
  </FlexRow>
</template>

<script>
import FlexRow from "@/components/atoms/FlexRow";
import ComponentMixin from "@/components/ComponentMixin";
import HotIcon from "@/components/atoms/HotIcon";
import Label from "@/components/atoms/Label";
export default {
  mixins: [ComponentMixin],
  name: "LastLoggedInLabel",
  components: {Label, HotIcon, FlexRow},
  props: {
    lastLoggedInAt: {
      type: String
    }
  },
  computed: {
    loggedInAt() {
      return this.fromNow(this.lastLoggedInAt)
    }
  }
}
</script>

<style scoped>

</style>